import styled from 'styled-components';
import { AllieText } from '../../../../../components/Text';

export const Container = styled.div`
  background: var(--allie-color-white);
  border: 1px solid var(--allie-color-light-60);
  border-radius: var(--allie-radius-xs);
  display: flex;
  flex-direction: column;
  width: 100%;
  container-type: inline-size;
  container-name: product-cost-card;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-lg);
  padding: var(--allie-spacing-lg);
  border-top: 1px solid var(--allie-color-light-60);
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-md);
  flex: 1;

  @container product-cost-card (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--allie-spacing-xs);
  }
`;

export const ProductInfoName = styled.div`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-md);
`;

export const IconContainer = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--allie-color-neutral-60);
`;

export const AllieTextProduced = styled(AllieText)`
  position: relative;
  @container product-cost-card (min-width: 600px) {
    margin-left: var(--allie-spacing-md);
    &::before {
      content: '|';
      position: absolute;
      left: calc(-1 * var(--allie-spacing-md));
      color: var(--allie-color-neutral-60);
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: var(--allie-color-light-80);
`;

export const MetricsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: var(--allie-spacing-xl);
`;

export const MetricColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 135px;
`;

export const ImpactColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: fit-content;
`;

export const ImpactContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-md);
`;

export const ImpactIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--allie-spacing-3xl);
  color: var(--allie-color-neutral-60);
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-lg);
`;

export const SeeMoreButton = styled.button`
  background: none;
  border: none;
  color: var(--allie-color-neutral-60);
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-xs);
  padding: var(--allie-spacing-md) 0;
  align-self: flex-start;
  
  &:hover {
    color: var(--allie-color-primary-80);
  }
  
  &:active {
    color: var(--allie-color-primary-90);
  }
`;
